<table>
    <tbody>
        <tr>
            <td></td>
            <td>{{ operatingLabel }}</td>
            <td>{{ operatingCurrent | finNumber : numberFormat }}</td>
            <td>{{ operatingPrevious | finNumber : numberFormat }}</td>
        </tr>
        <tr>
            <td></td>
            <td>{{ investingLabel }}</td>
            <td>{{ investingCurrent | finNumber : numberFormat }}</td>
            <td>{{ investingPrevious | finNumber : numberFormat }}</td>
        </tr>
        <tr>
            <td></td>
            <td>{{ financingLabel }}</td>
            <td>{{ financingCurrent | finNumber : numberFormat }}</td>
            <td>{{ financingPrevious | finNumber : numberFormat }}</td>
        </tr>
        <tr>
            <td>{{ totalIndex }}</td>
            <td>
                <input #titleInput hamInput type="text" [value]="totalName"
                    [placeholder]="'aumico_annual_report_proposal_enter_text' | i18next"
                    (input)="onTitleChange(titleInput.value)" />          </td>
            <td>{{ currentTotal | finNumber : numberFormat }}</td>
            <td>{{ previousTotal | finNumber : numberFormat }}</td>
        </tr>
    </tbody>
</table>
